module.exports = __webpack_public_path__ + "img/login_slide_01.acd76f55.webp";